module.exports = __webpack_public_path__ + "img/device_1012_1_select.892f50d0.svg";